// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-18[data-v-8c90aa7c]{font-size:18px!important}", ""]);
// Exports
module.exports = exports;
